import { render, staticRenderFns } from "./BulkAssign.vue?vue&type=template&id=52c69c24&scoped=true"
import script from "./BulkAssign.vue?vue&type=script&lang=js"
export * from "./BulkAssign.vue?vue&type=script&lang=js"
import style0 from "./BulkAssign.vue?vue&type=style&index=0&id=52c69c24&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c69c24",
  null
  
)

export default component.exports